import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { AppleIcon, PlayIcon } from "../../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

function CaseStudy(props) {
  return (
    <section
      className="casestudy p-100"
      id="case_btn"
      style={{ background: "#F5F5F5" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6}>
            <h2>
              Discover Our Recent Mobile <span>Game Application</span> Projects
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6}>
            <p>
              Discover TekRevol's pioneering Game App Development projects. As a
              premier force in the game development industry, our portfolio
              displays innovation, user-oriented designs, and advanced
              technology. Each project shows our commitment to creating
              customized gaming experiences, empowering clients to prosper in
              the dynamic world of mobile gaming. Experience the revolutionizing
              potential of partnering with TekRevol.
            </p>
          </Col>
          {/* <Col xs={12} md={6} lg={6} xl={7}>
            <div className="pro_btn">
              <Link to="/" aria-label="TekRevol Contact" className="border_btn">
                All case studies
              </Link>
            </div>
          </Col> */}
        </Row>
        <Row className="pro_sec">
          <Col xs={12} md={12} lg={12}>
            <div className="casestudy_item item_001">
              <StaticImage
                src="../../../images/locationgcc/game/fsk-case.webp"
                alt="TekRevol"
                className="banner-image"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1600}
                height={850}
              />
              <div className="download_section">
                <div className="download_apps">
                  <div className="name_now">Available Now!</div>
                  <div className="name_icon">
                    <ul>
                      <li>
                        <Link to="">{PlayIcon}</Link>
                      </li>
                      <li>
                        <Link to="">{AppleIcon}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="case_btn">
                  <Link
                    to="/case-studies/fsk"
                    aria-label="TekRevol Contact"
                    className="border_btn"
                  >
                    view case study
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <div className="casestudy_item item_002">
              <StaticImage
                src="../../../images/services-usa/game_update/ether_case_img.webp"
                alt="TekRevol"
                className="banner-image"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={784}
                height={850}
              />
              <div className="download_section">
                <div className="download_apps">
                  <div className="name_now">Available Now!</div>
                  <div className="name_icon">
                    <ul>
                      <li>
                        <Link to="">{PlayIcon}</Link>
                      </li>
                      <li>
                        <Link to="">{AppleIcon}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="case_btn">
                  <Link
                    to="/case-studies/ether-legends"
                    aria-label="TekRevol Contact"
                    className="border_btn"
                  >
                    view case study
                  </Link>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <div className="casestudy_item item_003">
              <StaticImage
                src="../../../images/services-usa/game_update/parcheesi_case_img.webp"
                alt="TekRevol"
                className="banner-image"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={784}
                height={850}
              />
              <div className="download_section">
                <div className="download_apps">
                  <div className="name_now">Available Now!</div>
                  <div className="name_icon">
                    <ul>
                      <li>
                        <Link to="">{PlayIcon}</Link>
                      </li>
                      <li>
                        <Link to="">{AppleIcon}</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="case_btn">
                  <Link
                    to="/case-studies/parcheesi"
                    aria-label="TekRevol Contact"
                    className="border_btn"
                  >
                    view case study
                  </Link>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CaseStudy;
